'use strict';

const scrollAnimate = require('../components/scrollAnimate');
const navigationCountry = $('.page').attr('data-navigation-country');
const validator = require('../components/clientSideValidation');

if (navigationCountry === 'CN') {
    var TencentCaptcha = require('../common/tencentCaptcha');
}

var GrecaptchaV3 = require('../common/grecaptchaV3');

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}
function uploadlistOfStores(data) {
    $('select.js-contactUs-stores').empty().html(data.listOfStoresHtml);
}

function closeDetailField() {
    if (!$('.js-contactUs-orderNumber').hasClass('cc-no-visible')) $('.js-contactUs-orderNumber').addClass('cc-no-visible');
    if (!$('.js-contactUs-sku').hasClass('cc-no-visible')) $('.js-contactUs-sku').addClass('cc-no-visible');
    if (!$('.js-contactUs-purchasewhere').hasClass('cc-no-visible')) $('.js-contactUs-purchasewhere').addClass('cc-no-visible');
    if (!$('.js-contactUs-purchasewhen').hasClass('cc-no-visible')) $('.js-contactUs-purchasewhen').addClass('cc-no-visible');
    if (!$('.js-contact-country').hasClass('cc-no-visible')) $('.js-contact-country').addClass('cc-no-visible');
    if (!$('.js-select-listOfStores').hasClass('cc-no-visible')) $('.js-select-listOfStores').addClass('cc-no-visible');
}

function closeSpecificField() {
    // picklist type of info
    if (!$('.js-contuctUs-reportProblem').hasClass('cc-no-visible')) $('.js-contuctUs-reportProblem').addClass('cc-no-visible');
    if (!$('.js-contactUs-orderreturn').hasClass('cc-no-visible')) $('.js-contactUs-orderreturn').addClass('cc-no-visible');
    if (!$('.js-contactUs-info').hasClass('cc-no-visible')) $('.js-contactUs-info').addClass('cc-no-visible'); ;
    if (!$('.js-contactUs-service').hasClass('cc-no-visible')) $('.js-contactUs-service').addClass('cc-no-visible'); ;
    closeDetailField();
}

function initCurrentDate() {
    var d = new Date();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + '/' + (month < 10 ? '0' : '') + month + '/' + (day < 10 ? '0' : '') + day;
}

function uploadSuccesPage($selector, data) {
    $selector.empty().html(data.succesPageHtml);
}

module.exports = {

    fixSelectPickerTabindex: function() {
        $('.btn').on( "focusout", function() {
            setTimeout(function () {
                $('.btn').attr('tabindex', "0");
            }, 100);
        });
    },

    removeAttributesForAccessibility: function(){
        $('.btn').removeAttr("aria-activedescendant");
    },

    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    displayMessage(data, button);
                    if (data.success) {
                        $('.contact-us').trigger('reset');
                    }
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    },
    changeColorTitleSelect: function() {
        $(document).ready(function() {
            $('#genderSelect option').each(function() {
                if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                    $('#genderSelect').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                }
            });
            $('#findStoreLanguageSelect option').each(function() {
                if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                    $('#findStoreLanguageSelect').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                }
            });
            $('#countryListSelect option').each(function() {
                if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                    $('#countryListSelect').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                }
            });
        });
    },
    openCloseFormSectionMobile: function() {
        var arrowUp = $('.js-openRequest-form').data('arrowup');
        var arrowDown = $('.js-openRequest-form').data('arrowdown');
        $(document).on('keypress click', '.cc-mobile .js-openRequest-form', function() {
            if ($('.cc-formSection').css('display') === 'block') {
                $('.cc-formSection').fadeOut();
                $('.js-icon-openRequest use').attr('xlink:href', arrowDown);
            } else {
                $('.cc-formSection').fadeIn();
                $('.js-icon-openRequest use').attr('xlink:href', arrowUp);
            }
        });
    },

    openRightForm: function() {
        $(document).on('change', '#contactUs #myquestion', function() {
            closeSpecificField();
            var questionvalue = $('#myquestion option:selected').val();
            switch (questionvalue) {
            case 'order':
                $('.js-contactUs-orderreturn').removeClass('cc-no-visible');
                break;
            case 'issues':
                $('.js-contuctUs-reportProblem').removeClass('cc-no-visible');
                break;
            case 'omnichannel':
                $('.js-contact-country').removeClass('cc-no-visible');
                $('.js-select-listOfStores').removeClass('cc-no-visible');
                break;
            case 'product':
                $('.js-contactUs-info').removeClass('cc-no-visible');
                break;
            case 'services':
                $('.js-contactUs-service').removeClass('cc-no-visible');
                break;
            }
        });
        $(document).on('change', '#contactUs #infocategory', function() {
            closeDetailField();
            var infoselected = $('#infocategory option:selected').val();
            switch (infoselected) {
            case 'materials':
            case 'care':
            case 'size':
            case 'other':
                $('.js-contactUs-sku').removeClass('cc-no-visible');
                break;
            case 'repair':
                var output = initCurrentDate();
                $('.js-contactUs-sku').removeClass('cc-no-visible');
                $('.js-contactUs-purchasewhere').removeClass('cc-no-visible');
                $('.js-contactUs-purchasewhen').removeClass('cc-no-visible');
                $('.js-contactUs-purchasewhen').val(output);
                break;
            }
        });

        $(document).on('change', '#contactUs #problem', function() {
            closeDetailField();
            var problem = $('#problem option:selected').val();
            switch (problem) {
            case 'product':
                var output = initCurrentDate();
                $('.js-contactUs-orderNumber').removeClass('cc-no-visible');
                $('.js-contactUs-sku').removeClass('cc-no-visible');
                $('.js-contactUs-purchasewhere').removeClass('cc-no-visible');
                $('.js-contactUs-purchasewhen').removeClass('cc-no-visible');
                $('.js-contactUs-purchasewhen').val(output);
                break;
            case 'order':
            case 'return':
            case 'shipping':
            case 'refund':
                $('.js-contactUs-orderNumber').removeClass('cc-no-visible');
                break;

            }
        });

        $(document).on('change', '#contactUs #servicescategory', function() {
            closeDetailField();
            var service = $('#servicescategory option:selected').val();
            switch (service) {
            case 'boutiqueappointment':
                $('.js-contact-country').removeClass('cc-no-visible');
                $('.js-select-listOfStores').removeClass('cc-no-visible');
                break;
            case 'sartoria':
                var url = $('#myquestion').data('urlsartoria');
                window.location = url;
                break;
            case 'casaCucinelli':
                var url = $('#myquestion').data('urlshowroom');
                window.location = url;
                break;
            case 'vicuna':
                var url = $('#myquestion').data('urlvicuna');
                window.location = url;
                break;
            }
        });

        $(document).on('change', '#contactUs #ordercategory', function() {
            closeDetailField();
            var orderType = $('#ordercategory option:selected').val();
            if (orderType === 'shippinginfo' || orderType === 'cancellationrequest' || orderType === 'shippingupdate' || orderType === 'labelrequest') {
                $('.js-contactUs-orderNumber').removeClass('cc-no-visible');
            }
        });
    },

    uploadListOfStores: function() {
        $(document).on('change', '.js-contactUs-counrty', function() {
            if (!$('.js-contact-country').hasClass('cc-no-visible')) {
                var url = $('select.js-contactUs-counrty').data('liststores');
                var countryCode = $('select.js-contactUs-counrty').val();
                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    data: {
                        countryCode: countryCode
                    },
                    success: function (data) {
                        $.spinner().stop();
                        uploadlistOfStores(data);
                        $('select.js-contactUs-stores').selectpicker('refresh');
                        $('.js-select-listOfStores').removeClass('cc-no-visible');
                    }
                });
            }
        });
    },

    submitContactUsForm: function() {
        $(document).on('click', '.js-contactUs-submit', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const $form = $('#contactUs');
            const url = $('.js-contactUs-action').data('action');
            let labelAnalytics = $('#myquestion option:selected').val();
            let labelNote;

            switch (labelAnalytics) {
            case 'order':
                labelNote = $('#ordercategory option:selected').val();
                break;
            case 'issues':
                labelNote = $('#problem option:selected').val();
                break;
            case 'product':
                labelNote = $('#infocategory option:selected').val();
                break;
            case 'services':
                labelNote = $('#servicescategory option:selected').val();
                break;
            }

            if (labelNote) {
                labelAnalytics += ' - ' + labelNote;
            }

            const checkHoneyPot = $('.contact_me_if_spam').val();
            const isSpam = checkHoneyPot.length > 0;

            const valid = validator.functions.validateContactUsform();
            if (!valid) return true;

            function doSubmit() {
                if (isSpam) return;

                $form.spinner().start();
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: $form.serialize(),
                    success: function (data) {
                        dataLayer.push({
                            event: 'contactUs',
                            eventCategory: 'Contact Us',
                            eventAction: data.success ? 'submit_ok' : 'submit_fail',
                            eventLabel: labelAnalytics,
                            userScore: data.userScore
                        });
                        $.spinner().stop();
                        uploadSuccesPage($form, data);
                        $('.js-openRequest-form').fadeOut();
                        $('.cc-requestSection .cc-subtitle').fadeOut();
                        scrollAnimate(0, {duration: 100});
                    },
                    error: function (data) {
                        dataLayer.push({
                            event: 'contactUs',
                            eventCategory: 'Contact Us',
                            eventAction: 'submit_fail',
                            eventLabel: labelAnalytics
                        });
                        $.spinner().stop();
                        uploadSuccesPage($form, data.responseJSON);
                        $('.js-openRequest-form').fadeOut();
                        $('.cc-requestSection .cc-subtitle').fadeOut();
                        scrollAnimate(0, {duration: 100});
                    }
                });
            }

            if ($('.js-tencent-captcha-container').length) {
                const readyToSubmit = $.Deferred();
                const $tencentCaptchaEl = $('.js-tencent-captcha-container', $form);
                TencentCaptcha.initialize($tencentCaptchaEl, readyToSubmit);
                readyToSubmit.done(doSubmit);
            } else {
                GrecaptchaV3.initialize(doSubmit);
            }

            return false;
        });
    },

    fillChecboxStoreSelected: function() {
        $(document).on('change', '#genericCusBoutique', function() {
            var $boutique = $('#' + this.id + ' option:selected');
            var name = $boutique.data('name');
            var address1 = $boutique.data('address1');
            var phone = $boutique.data('phone');
            $('.js-store-name').empty().html(name);
            $('.js-store-addres').empty().html(address1);
            $('.js-store-phone').empty().html(phone);
            $('.cc-selected-boutique').removeClass('cc-no-visible');
        });
    },

    // use for submit
    submitGenericCusForm: function() {
        $(document).on('click', '.js-genericCus-submit', function(e) {
            var url = $(this).closest('.js-genericCus-action').data('action');
            var $form = $(this).closest('form.generic-cus-form');
            var formId = `#${$form.attr('id')}`;
            var eventLabel = $('input[name="cus"]', $form).val();
            const readyToSubmit = $.Deferred();

            if (navigationCountry === 'CN') {
                // initialize tencent captcha
                var $tencentCaptchaEl = $('.js-tencent-captcha-container', $form);
                TencentCaptcha.initialize($tencentCaptchaEl, readyToSubmit);
            } else {
                readyToSubmit.resolve();
            }

            readyToSubmit.done(function() {
                $form.spinner().start();
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: $form.serialize(),
                    success: function (data) {
                        if (data.success) {
                            // analytics
                            dataLayer.push({
                                event: 'contactUs',
                                eventCategory: 'Contact Us',
                                eventAction: 'submit_ok',
                                eventLabel: eventLabel
                            });
                        } else {
                            dataLayer.push({
                                event: 'contactUs',
                                eventCategory: 'Contact Us',
                                eventAction: 'submit_fail',
                                eventLabel: eventLabel
                            });
                        }
                        // END
                        $.spinner().stop();
                        uploadSuccesPage($(formId), data);
                    },
                    error: function (data) {
                        $form.spinner().stop();
                        // analytics
                        dataLayer.push({
                            event: 'contactUs',
                            eventCategory: 'Contact Us',
                            eventAction: 'submit_fail',
                            eventLabel: eventLabel
                        });
                        // END
                    }
                });
            });
        });
    },

    enableWhatsApp: function() {
        $(document).ready(function() {
            var $whatsApp = $('.js-whatsapp-integration-contactPage');
            var url = $whatsApp.data('url');
            if (!$('.js-chatSection-enable').hasClass('d-none')) {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    success: function (data) {
                        if (data.enableInThisCountry) {
                            $whatsApp.fadeIn();
                            $whatsApp.attr('href', data.overrideLink);
                        } else {
                            $('.js-whatsapp-row').remove();
                        }
                        $.spinner().stop();
                    },
                    error: function (err) {
                        $('.js-whatsapp-row').remove();
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    checkEx: function() {
        $(document).ready(function() {
            var contentSlotLength = $('.js-exceptional-closure-slot').children().length;
            var contentAssetLength = $('.js-chatSection-enable').children().length;

            if (contentSlotLength > 0 || contentAssetLength > 0) {
                $('.js-requestSection').addClass('col-sm-6');
            } else {
                $('.js-requestSection').removeClass('col-sm-6');
            }
        });
    },

    noOrientalCheck: function () {
        $(document).on('focusout', '.js-no-oriental', function () {
            var validationMsg = $(this).data('oriental-error');
            var regex = /^[a-zA-Z0-9 -_\/(){}|"!? ’'‘ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]+$/;
            var value = $(this).val();
            var valid = regex.test(value);
            if (value && value !== '') {
                if (!valid) {
                    $(this)
                        .addClass('cc-error')
                        .siblings('.cc-feedback-message').children('.cc-text-message')
                        .text(validationMsg);
                    this.setCustomValidity('noOriental');
                    $(this).attr('data-no-oriental', false);
                } else {
                    if ($(this).hasClass('cc-error')) {
                        $(this)
                            .removeClass('cc-error')
                            .siblings('.cc-feedback-message').children('.cc-text-message')
                            .text('');
                        this.setCustomValidity('');
                        $(this).attr('data-no-oriental', true);
                    }
                }
            }
        });
    },
    cleareSelectMyQuestion: function() {
        $(document).ready(function() {
            $('#contactUs #myquestion').selectpicker('deselectAll');
            $('#myquestion option:selected').prop('selected', false);
            $('#contactUs #myquestion').selectpicker('refresh');
        });
    }

};
